import { YStack } from "tamagui";

import {
  OverviewBalance,
  OverviewDangers,
  OverviewHowareu,
  OverviewInsights,
  OverviewInvolvement,
  OverviewMetrics,
  OverviewScales,
  OverviewWellbeing,
} from "~/components/feature/overview";
import { MainPageWrapper } from "~/components/layout";

const Overview = () => {
  return (
    <MainPageWrapper>
      <YStack gap={"$3"}>
        <OverviewMetrics />
        <OverviewInvolvement />
        <OverviewWellbeing />
        <OverviewDangers />
        <OverviewScales />
        <OverviewBalance />
        <OverviewInsights />
        <OverviewHowareu />
      </YStack>
    </MainPageWrapper>
  );
};
export default Overview;
